import { render } from "./BaseSpan.vue?vue&type=template&id=419bce86&scoped=true"
import script from "./BaseSpan.vue?vue&type=script&lang=js"
export * from "./BaseSpan.vue?vue&type=script&lang=js"

import "./BaseSpan.vue?vue&type=style&index=0&id=419bce86&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419bce86"]])

export default __exports__